import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PortalService } from 'src/app/portal/services/portal.service';

@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss'],
})
export class PublicLayoutComponent {
  entidad$ = this.portalService.currentEntity$;

  constructor(private portalService: PortalService, private router: Router) {}

  irALogin(slug?: string) {
    if (slug) {
      this.router.navigate(['/', slug, 'login']);
    } else {
      console.warn('Slug no definido, redirigiendo a login general.');
      this.router.navigate(['/']);
    }
  }

  irAlHome() {
    this.router.navigate(['/']);
  }
}
